var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"record-button",class:{ 'record-button--recording': _vm.recording },attrs:{"type":_vm.buttonType,"circle":""},on:{"click":_vm.toggleRecording}},[_c('ion-icon',{staticClass:"record-button__icon",attrs:{"name":_vm.buttonIcon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bff29958","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeBook/RecordButton.vue
// module id = null
// module chunks = 